import { Link } from "react-router";
import { TaxLayout } from "../../components/tax/TaxLayout.js";
import { Card, StatCard } from "../../components/design-system/index.js";

/**
 * /tax — Overview tile grid linking out to each sub-route. Phase 7
 * Session 1.
 *
 * v1: static "what's here" map. Phase 7 Session 2 may layer in the
 * latest projection's headline numbers + a "things to do" feed
 * (overdue tax documents, safe-harbor warnings, ACA cliff if MAGI is
 * close).
 */

const TILES: { to: string; label: string; sub: string }[] = [
  {
    to: "/tax/quarterly",
    label: "Quarterly projection",
    sub: "Federal + NY + NYC liability with safe harbor",
  },
  {
    to: "/tax/capital-gains",
    label: "Capital gains preview",
    sub: "Realized + unrealized × LT/ST + wash-sale flags",
  },
  {
    to: "/tax/roth-ladder",
    label: "Roth conversion ladder",
    sub: "Year-by-year conversion modeler + 5-year clock",
  },
  {
    to: "/tax/sepp",
    label: "Rule 72(t) / SEPP",
    sub: "Pre-59½ access methods (RMD / amortization / annuity)",
  },
  {
    to: "/tax/aca-planner",
    label: "ACA subsidy planner",
    sub: "MAGI vs 400% FPL cliff visualization",
  },
  {
    to: "/tax/documents",
    label: "Tax documents",
    sub: "1099 / W-2 / K-1 receipt status checklist",
  },
];

export function TaxPage() {
  return (
    <TaxLayout
      title="Tax math"
      subtitle="The household's tax-planning surface. Federal + NY + NYC, FIRE-aware."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className="block">
            <Card className="p-5 h-full hover:border-[var(--color-accent)] transition-colors">
              <div className="text-base font-semibold text-[var(--color-text)] mb-1">
                {t.label}
              </div>
              <div className="text-sm text-[var(--color-muted)]">{t.sub}</div>
            </Card>
          </Link>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard label="Bracket year" value="2025 + 2026" sub="IRS Rev Proc 2024-40 / 2025-32" />
        <StatCard label="Wash-sale window" value="61 days" sub="30 before + sale day + 30 after" />
        <StatCard label="ACA assumption" value="IRA-extended" sub="Toggle on /tax/aca-planner" />
      </div>
    </TaxLayout>
  );
}
